import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { trackModDeleted } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { confirm } from "@src/store/slices/experienceBuilder/common/utils/confirm";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const deleteMod = createAsyncThunk<boolean, string>(
  "experienceBuilder/deleteMod",
  async (modificationId, { dispatch, getState }) => {
    // Get mod before deletion for tracking
    const mods = experienceBuilderSlice.selectors.getMods(getState());
    const mod = mods.find((m) => m.id === modificationId);

    const result = await confirm(dispatch, {
      title: "Delete modification",
      message: "Are you sure you want to delete this modification?",
    });

    if (result === "confirm") {
      dispatch(
        experienceBuilderSlice.actions.updateMods({
          remove: [modificationId],
        })
      );

      if (mod) {
        void dispatch(trackModDeleted({ mod }));
      }
      return true;
    } else {
      return false;
    }
  }
);
